import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { ConfigProvider } from "antd";
import { HelmetProvider } from "react-helmet-async";

const resizeObserverErr = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
const prevOnError = window.onerror;
window.onerror = function (msg, ...rest) {
  if (typeof msg === "string" && resizeObserverErr.test(msg)) return true;
  return prevOnError ? prevOnError.apply(this, [msg, ...rest]) : false;
};

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <ConfigProvider>
        <App />
      </ConfigProvider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
